import { render, staticRenderFns } from "./BadgeboxSuccess.vue?vue&type=template&id=a9e35c7e&"
import script from "./BadgeboxSuccess.vue?vue&type=script&lang=js&"
export * from "./BadgeboxSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports